import { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";
import { AuthShell } from "@/components/AuthShell";
import { Field, PasswordInput, PrimaryButton } from "@/components/FormBits";

export default function SignInPage() {
  const { login } = useAuth();
  const [f, setF] = useState({ email: "", password: "", remember: false });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await login(f.email, f.password, f.remember);
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell title="Welcome back" sub="Sign in to continue your pigment decisions."
      footer={<>New to Ink Genius? <Link to="/signup" data-testid="signin-signup-link" className="font-semibold text-[#2C1810] underline decoration-[#C5A059] underline-offset-4">Create an account</Link></>}>
      <form onSubmit={submit} className="space-y-5" data-testid="signin-form">
        <Field label="Email address" id="signin-email-input" type="email" autoComplete="email" required value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} />
        <div>
          <div className="flex items-center justify-between">
            <label htmlFor="signin-password-input" className="text-[11px] font-semibold uppercase tracking-[0.18em] text-[#6E5549]">Password</label>
            <Link to="/forgot-password" data-testid="signin-forgot-link" className="text-xs font-semibold text-[#9C6218] underline-offset-2 hover:underline">Forgot password?</Link>
          </div>
          <div className="mt-1.5"><PasswordInput id="signin-password-input" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} /></div>
        </div>
        <label className="flex cursor-pointer items-start gap-3 text-sm text-[#4A3B32]" htmlFor="signin-remember">
          <input id="signin-remember" type="checkbox" checked={f.remember} onChange={(e) => setF({ ...f, remember: e.target.checked })} data-testid="signin-remember-checkbox" className="mt-0.5 h-4 w-4 accent-[#2C1810]" />
          <span>Keep me signed in for 30 days<span className="block text-xs text-[#A88B7D]">Only tick this on your own device.</span></span>
        </label>
        {error && <p role="alert" data-testid="signin-error" className="rounded-xl bg-[#F9ECEC] px-4 py-3 text-sm text-[#8C2A2A]">{error}</p>}
        <PrimaryButton type="submit" disabled={busy} data-testid="signin-submit-btn" className="w-full">{busy ? "Signing in…" : "Sign in"}</PrimaryButton>
      </form>
    </AuthShell>
  );
}
